import {
  Button,
  Modal,
  OutstandingItem,
  P,
  displayCentsInDollars,
} from '@vgrubs/components';

type Props = {
  /** The item whose failed bank payment is retried; null keeps it shut. */
  item: OutstandingItem | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => Promise<boolean>;
};

/**
 * A retry debits the owner's bank account again, so it is confirmed first -
 * the Client Payments list retries on one click, but there the button sits on
 * the payment itself, not on a debt that may already be settled another way.
 */
export const RetryPaymentModal = ({
  item,
  busy,
  onClose,
  onConfirm,
}: Props) => (
  <Modal
    isOpen={!!item}
    closeModal={onClose}
    logo={false}
    header="Retry bank payment"
  >
    {item && (
      <>
        <P $mb="24" $center>
          Bank payment #{item.clientPaymentId}, behind this{' '}
          {displayCentsInDollars(item.amount)} charge, is sent to the
          owner&apos;s bank again. It takes 3-5 business days to clear.
        </P>
        <Button
          $selected
          $w="100%"
          $loading={busy}
          disabled={busy}
          onClick={async () => {
            const ok = await onConfirm();
            if (ok) onClose();
          }}
        >
          Retry payment
        </Button>
        <Button $selected $gray $w="100%" $mt="16" onClick={onClose}>
          Cancel
        </Button>
      </>
    )}
  </Modal>
);
